import { createContext } from 'react';

const topScoreContext = createContext(null);

export default topScoreContext;
